import React from 'react';

export default function AddItemPopup({ isOpen, message, onClose, duration = 2500 }) {
  React.useEffect(() => {
    if (!isOpen) return;
    const t = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => clearTimeout(t);
  }, [isOpen, duration, onClose]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{ pointerEvents: 'none' }}
      className="fixed top-6 right-0 z-[10000] w-full max-w-sm px-4"
    >
      <div
        className={`ml-auto transform transition-all duration-300 ${
          isOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
        }`}
      >
        <div
          className="shadow-xl border rounded-lg"
          style={{
            background: 'var(--raisin-black-1)',
            borderColor: 'var(--orange)',
            color: 'var(--white)',
            pointerEvents: 'auto',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px var(--orange)',
            backdropFilter: 'none',
          }}
          role="status"
        >
          <div className="p-4 flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <div 
                className="w-6 h-6 rounded-full flex items-center justify-center"
                style={{ 
                  background: 'var(--orange)',
                  color: 'var(--raisin-black-1)'
                }}
              >
                ✓
              </div>
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Added to cart</p>
              <p className="font-semibold leading-snug" style={{ color: 'var(--white)' }}>{message}</p>
            </div>
            <button
              onClick={onClose}
              className="px-2 py-1 text-sm rounded hover:bg-orange-500/20 transition-colors"
              style={{ 
                color: 'var(--orange)',
                fontSize: '18px',
                fontWeight: 'bold',
                minWidth: '24px',
                minHeight: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-label="Close notification"
            >
              ×
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


